import { render, staticRenderFns } from "./EditPreset.vue?vue&type=template&id=50b01b1f&"
import script from "./EditPreset.vue?vue&type=script&lang=ts&"
export * from "./EditPreset.vue?vue&type=script&lang=ts&"
import style0 from "./EditPreset.vue?vue&type=style&index=0&id=50b01b1f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports